export const ACTION_INIT = 'product-customization.init';
export const SELECT_MODE = 'product-customization.select_mode';
export const ADD_INGREDIENT = 'product-customization.add_ingredient';
export const REMOVE_INGREDIENT = 'product-customization.remove_ingredient';
export const COLLAPSE_GROUP = 'product-customization.collapse_group';
export const UNPACK_GROUP = 'product-customization.unpack_group';
export const FINISH = 'product-customization.finish';

export function init(initialState) {
    return {type: ACTION_INIT, payload: {initialState}};
}

export function selectMode(mode) {
    return {type: SELECT_MODE, payload: {mode}};
}

export function addIngredient(ingredient) {
    return {type: ADD_INGREDIENT, payload: {ingredient}};
}

export function removeIngredient(ingredient) {
    return {type: REMOVE_INGREDIENT, payload: {ingredient}};
}

export function collapseGroup(group) {
    return {type: COLLAPSE_GROUP, payload: {group}};
}

export function unpackGroup(group) {
    return {type: UNPACK_GROUP, payload: {group}};
}

export function finish() {
    return {type: FINISH, payload: {}};
}
